import React, { useContext } from "react";
import HowItWorks from "./componentsHero/HowItWorks";
import { UserTypeContext } from "../context/UserTypeContext";
import DetailBusiness from "./heroComponents/DetailBusiness";
import InstagramReel from "./heroComponents/reelsInstagram/InstagramReel";
/* import InstagramReels from './InstagramReels/InstagramReels'; */
import Plans from "../components/Plans/Plans.jsx"
import AnimatedSection from "../tools/AnimatedSection.jsx";


const Hero = () => {
  const { setUserType } = useContext(UserTypeContext);

  function createUserProfesional() {
    //console.log("click in register Profesional");
    setUserType("Profesional");
  }
  function createUserClients() {
   // console.log("click in register createUserClients");
    setUserType("Clients");
  }

  return (
    <>
      <section id="home" className="bg-gradient-to-b from-[#edc3e7] via-white to-[#edc3e7] py-[-12px] md:py-10" >
        <DetailBusiness createUserClients={createUserClients} createUserProfesional={createUserProfesional} />
      <AnimatedSection delay={0.3} >
        <HowItWorks createUserClients={createUserClients} createUserProfesional={createUserProfesional} />
      </AnimatedSection>

      <AnimatedSection delay={0.3} >
        <Plans />
      </AnimatedSection>

        {/* <ReelsComponentFaceboock/> */}
        <AnimatedSection delay={0.3} >
        <InstagramReel/>
        </AnimatedSection>

      </section>
    </>
  );
};

export default Hero;
